import { useMemo } from 'react'
import { ShowtimeReleaseType } from '@/types/codegen-federation'
import { ShowtimesVenue } from '../hooks/useVenueSearch/useVenueSearch'

const getVenuesSortedByDistance = (venues: ShowtimesVenue[]) => {
  return venues.sort((a, b) => {
    if (a.distance === undefined) return 1
    if (b.distance === undefined) return -1
    return a.distance - b.distance
  })
}

const useSortedVenues = ({
  venues,
  releaseTypeFilter,
}: {
  venues: ShowtimesVenue[]
  releaseTypeFilter: ShowtimeReleaseType[]
}) => {
  const venuesWithShowtimes = useMemo(() => {
    return getVenuesSortedByDistance(
      venues
        ?.map((venue) => ({
          ...venue,
          showtimes: venue?.showtimes.filter(
            (showtime) => releaseTypeFilter.length === 0 || releaseTypeFilter.includes(showtime.releaseType),
          ),
        }))
        .filter((venue) => venue?.showtimes.length > 0) ?? [],
    )
  }, [venues, releaseTypeFilter])

  const venuesWithNoShowtimes = useMemo(() => {
    const filtered = venues?.filter((venue) => {
      if (releaseTypeFilter.length > 0) {
        return venue?.showtimes.every((showtime) => !releaseTypeFilter.includes(showtime.releaseType))
      }
      return venue?.showtimes.length === 0
    })
    return getVenuesSortedByDistance(filtered)
  }, [venues, releaseTypeFilter])

  return { venuesWithShowtimes, venuesWithNoShowtimes }
}

export default useSortedVenues
